// import React, { useState, useEffect, useMemo } from "react";
// import styled, { ThemeProvider, createGlobalStyle } from "styled-components";
// import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import { darkTheme, lightTheme } from "./utils/Themes";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// import Navbar from "./components/Navbar";
// import Hero from "./components/sections/Hero";
// // import CodeArena from "./components/sections/CodeArena";
// import Skills from "./components/sections/Skills";
// import Projects from "./components/sections/Projects";
// import Education from "./components/sections/Education";
// import Contact from "./components/sections/Contact";
// import Experience from "./components/sections/Experience";
// import Footer from "./components/sections/Footer";
// import LikeDislike from "./components/sections/LikeDislike.jsx";
// import Certification from "./components/sections/Certification.jsx";
// // import Game from "./components/sections/Game.jsx";
// import { useCachedFetch } from "./hooks/useCachedFetch";
// import { useBioFetch } from "./hooks/useBioFetch";
// import Analytics from "./components/sections/Analytics.jsx";
// import Album from "./components/sections/Album.jsx";
// import AppLoading from "./AppLoading.jsx";
// // import Achievements from "./components/sections/Achievements.jsx";
// import NotFound from "./components/sections/NotFound.jsx";

// const Body = styled.div`
//   background-color: ${({ theme }) => theme.bg};
//   width: 100%;
//   overflow-x: hidden;
//   position: relative;
// `;

// const Wrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   padding: 0 20px;
//   margin-top: 20px;
// `;

// const GlobalStyle = createGlobalStyle`
//   ::selection {
//     background: ${({ theme }) => theme.selectionBg};
//     color: ${({ theme }) => theme.selectionText};
//   }

//   ::-moz-selection {
//     background: ${({ theme }) => theme.selectionBg};
//     color: ${({ theme }) => theme.selectionText};
//   }
// `;

// function AppWrapper() {
//   const BaseURL = "https://saikrishna-portfolio.onrender.com/api";

//   const skillsData = useCachedFetch(`${BaseURL}/skills`, "skills_data");
//   const certData = useCachedFetch(
//     `${BaseURL}/certifications`,
//     "certifications_data"
//   );
//   const eduData = useCachedFetch(`${BaseURL}/education`, "education_data");
//   const projectsData = useCachedFetch(`${BaseURL}/projects`, "projects_data");
//   const experienceData = useCachedFetch(
//     `${BaseURL}/experience`,
//     "experience_data"
//   );
//   const achievementsData = useCachedFetch(
//     `${BaseURL}/achievements`,
//     "achievements_data"
//   );

//   // const leetcode = useCachedFetch(
//   //   `${BaseURL}/leetcode/HPFPYDG8GW`,
//   //   "leetcodeStats",
//   //   1
//   // );

//   // const gfg = useCachedFetch(
//   //   `${BaseURL}/gfg/saikrishnapyowf`,
//   //   "gfgStats",
//   //   1,
//   //   (data) => ({
//   //     userName: data.info.userName,
//   //     fullName: data.info.fullName,
//   //     institute: data.info.institute,
//   //     instituteRank: data.info.instituteRank,
//   //     currentStreak: data.info.currentStreak,
//   //     maxStreak: data.info.maxStreak,
//   //     codingScore: data.info.codingScore,
//   //     monthlyScore: data.info.monthlyScore,
//   //     totalSolved: data.info.totalProblemsSolved,
//   //     profilePicture: data.info.profilePicture,
//   //   })
//   // );

//   const { bio, loading, error } = useBioFetch(1);

//   // ✅ GLOBAL APP START / REFRESH LOADING ONLY
//   const isAppLoading = useMemo(() => {
//     return (
//       skillsData.loading ||
//       certData.loading ||
//       eduData.loading ||
//       projectsData.loading ||
//       experienceData.loading ||
//       achievementsData.loading ||
//       loading
//     );
//   }, [
//     skillsData.loading,
//     certData.loading,
//     eduData.loading,
//     projectsData.loading,
//     experienceData.loading,
//     achievementsData.loading,
//     loading,
//   ]);

//   const getInitialTheme = () => {
//     const hour = new Date().getHours();
//     return hour >= 7 && hour < 19 ? "light" : "dark"; // Light from 7am to 6:59pm
//   };

//   const [themeMode, setThemeMode] = useState(getInitialTheme);

//   // Optional: Auto update theme every minute

//   useEffect(() => {
//     const interval = setInterval(() => {
//       const hour = new Date().getHours();
//       const newTheme = hour >= 7 && hour < 19 ? "light" : "dark";

//       setThemeMode((prevTheme) => {
//         if (prevTheme !== newTheme) {
//           toast.success(
//             `We've automatically switched to ${
//               newTheme === "dark" ? "Dark Mode" : "Light Mode"
//             } to match your time of day. Enjoy a better viewing experience!`,
//             {
//               position: "top-right",
//               autoClose: 3000,
//               theme: newTheme,
//             }
//           );
//           return newTheme;
//         }
//         return prevTheme;
//       });
//     }, 30000); // every 30 seconds

//     return () => clearInterval(interval);
//   }, []);

//   const toggleTheme = () => {
//     setThemeMode((prev) => (prev === "dark" ? "light" : "dark"));
//   };

//   const theme = themeMode === "dark" ? darkTheme : lightTheme;

//   // ✅ SHOW FULL SCREEN LOADER ONLY ON APP START / REFRESH
//   if (isAppLoading) {
//     return <AppLoading />;
//   }

//   // ✅ ERROR FRIENDLY FALLBACK UI
//   // if (
//   //   error ||
//   //   skillsData.error ||
//   //   certData.error ||
//   //   eduData.error ||
//   //   projectsData.error ||
//   //   experienceData.error
//   // ) {
//   //   return (
//   //     <div
//   //       style={{
//   //         minHeight: "100vh",
//   //         display: "flex",
//   //         flexDirection: "column",
//   //         alignItems: "center",
//   //         justifyContent: "center",
//   //         background: "#000",
//   //         color: "#fff",
//   //         textAlign: "center",
//   //         padding: "20px",
//   //       }}
//   //     >
//   //       <h2>⚠️ Something went wrong</h2>
//   //       <p>Please check your internet connection and reload the page.</p>
//   //       <button
//   //         onClick={() => window.location.reload()}
//   //         style={{
//   //           marginTop: "20px",
//   //           padding: "10px 20px",
//   //           cursor: "pointer",
//   //           borderRadius: "6px",
//   //           border: "none",
//   //         }}
//   //       >
//   //         Reload Page
//   //       </button>
//   //     </div>
//   //   );
//   // }

//   return (
//     <ThemeProvider theme={theme}>
//       <GlobalStyle />

//       <Navbar
//         toggleTheme={toggleTheme}
//         currentTheme={themeMode}
//         bio={bio}
//         loading={loading}
//         error={error}
//       />

//       <Body>
//         <ToastContainer />
//         <Wrapper>
//           <Hero bio={bio} loading={loading} error={error} />


//           {/* 
//            <Game theme={themeMode} />
//             <CodeArena
//             leetcodeStats={leetcode.data}
//             leetcodeLoading={leetcode.loading}
//             gfgStats={gfg.data}
//             gfgLoading={gfg.loading}
//           /> */}

//           <Skills skills={skillsData.data} loading={skillsData.loading} />

//           <Certification
//             certifications={certData.data}
//             loading={certData.loading}
//           />

//           <Projects
//             projects={projectsData.data || []}
//             loading={projectsData.loading}
//           />

//           <Experience
//             experienceData={experienceData.data}
//             loading={experienceData.loading}
//           />
//           {/* <Achievements
//             theme={theme}
//             achievements={achievementsData.data?.data || []}
//             loading={achievementsData.loading}
//             error={achievementsData.error}
//           /> */}

//           <Education educationData={eduData.data} loading={eduData.loading} />

//           <Contact />
//           <LikeDislike />
//           <Footer bio={bio} loading={loading} error={error} />
//         </Wrapper>
//       </Body>
//     </ThemeProvider>
//   );
// }

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <AppWrapper />,
//   },
//   {
//     path: "/analytics",
//     element: <Analytics />,
//   },
//   {
//     path: "/album",
//     element: <Album />,
//   },

//   // ✅ 404 FALLBACK ROUTE — DO NOT REMOVE
//   {
//     path: "*",
//     element: <NotFound />,
//   },
// ]);

// function App() {
//   return <RouterProvider router={router} />;
// }

// export default App;




import React, { useCallback, useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const NEW_PORTFOLIO_URL = "https://saikrishnap.vercel.app/";
const REDIRECT_SECONDS = 10;
const MOBILE_BREAKPOINT = 768;

function RedirectPage() {
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_SECONDS);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth <= MOBILE_BREAKPOINT
  );

  const redirectToNewPortfolio = useCallback(() => {
    if (isRedirecting) return;

    setIsRedirecting(true);
    window.location.replace(NEW_PORTFOLIO_URL);
  }, [isRedirecting]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isRedirecting) return undefined;

    const timer = setInterval(() => {
      setSecondsLeft((previousSeconds) => {
        if (previousSeconds <= 1) {
          return 0;
        }

        return previousSeconds - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isRedirecting]);

  useEffect(() => {
    if (secondsLeft === 0 && !isRedirecting) {
      redirectToNewPortfolio();
    }
  }, [secondsLeft, isRedirecting, redirectToNewPortfolio]);

  const progress =
    ((REDIRECT_SECONDS - secondsLeft) / REDIRECT_SECONDS) * 100;

  return (
    <div
      style={{
        minHeight: "100dvh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8fafc",
        color: "#0f172a",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
        padding: isMobile ? "16px" : "24px",
        boxSizing: "border-box",
      }}
    >
      <main
        style={{
          width: "100%",
          maxWidth: "1150px",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "stretch",
          backgroundColor: "#ffffff",
          border: "1px solid #e2e8f0",
          borderRadius: isMobile ? "16px" : "20px",
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(15, 23, 42, 0.08)",
        }}
      >
        {/* Left Section */}
        <div
          style={{
            flex: "1 1 58%",
            padding: isMobile ? "32px 24px" : "48px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            borderRight: isMobile ? "none" : "1px solid #e2e8f0",
            borderBottom: isMobile ? "1px solid #e2e8f0" : "none",
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              width: "fit-content",
              padding: "7px 12px",
              marginBottom: isMobile ? "14px" : "16px",
              borderRadius: "999px",
              backgroundColor: "#ecfdf5",
              border: "1px solid #bbf7d0",
              color: "#15803d",
              fontSize: "11px",
              fontWeight: "800",
              letterSpacing: "0.7px",
            }}
          >
            ● PORTFOLIO UPDATED
          </div>

          <h1
            style={{
              margin: "0 0 12px",
              fontSize: isMobile
                ? "clamp(30px, 9vw, 40px)"
                : "clamp(32px, 4vw, 52px)",
              lineHeight: "1.08",
              letterSpacing: isMobile ? "-1.2px" : "-2px",
              fontWeight: "800",
              color: "#0f172a",
            }}
          >
            I&apos;ve moved to a new portfolio.
          </h1>

          <p
            style={{
              margin: 0,
              maxWidth: "650px",
              color: "#64748b",
              fontSize: isMobile ? "15px" : "17px",
              lineHeight: "1.6",
            }}
          >
            You&apos;re viewing my previous portfolio. Visit my new portfolio
            for my latest projects, experience, and updates.
          </p>
        </div>

        {/* Right Section */}
        <div
          style={{
            flex: "1 1 42%",
            width: isMobile ? "100%" : "auto",
            minWidth: 0,
            padding: isMobile ? "28px 24px 32px" : "40px",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            backgroundColor: "#f8fafc",
          }}
        >
          <div
            style={{
              width: isMobile ? "52px" : "58px",
              height: isMobile ? "52px" : "58px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: isMobile ? "14px" : "16px",
              backgroundColor: "#eff6ff",
              border: "1px solid #bfdbfe",
              fontSize: isMobile ? "24px" : "28px",
              marginBottom: "16px",
            }}
          >
            🚀
          </div>

          <div
            style={{
              fontSize: "12px",
              color: "#64748b",
              marginBottom: "5px",
              fontWeight: "700",
              letterSpacing: "0.5px",
            }}
          >
            NEW PORTFOLIO
          </div>

          <div
            style={{
              fontSize: isMobile ? "17px" : "19px",
              color: "#2563eb",
              fontWeight: "800",
              marginBottom: isMobile ? "20px" : "24px",
              wordBreak: "break-word",
            }}
          >
            saikrishnap.vercel.app
          </div>

          <button
            type="button"
            onClick={redirectToNewPortfolio}
            disabled={isRedirecting}
            style={{
              width: "100%",
              minHeight: "52px",
              padding: "14px 20px",
              border: "1px solid #2563eb",
              borderRadius: "12px",
              backgroundColor: "#2563eb",
              color: "#ffffff",
              fontSize: isMobile ? "15px" : "16px",
              fontWeight: "800",
              cursor: isRedirecting ? "wait" : "pointer",
              opacity: isRedirecting ? 0.8 : 1,
              WebkitTapHighlightColor: "transparent",
              touchAction: "manipulation",
            }}
          >
            {isRedirecting
              ? "Opening New Portfolio..."
              : "Visit New Portfolio →"}
          </button>

          <div style={{ marginTop: isMobile ? "20px" : "24px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "12px",
                marginBottom: "9px",
                fontSize: isMobile ? "12px" : "13px",
              }}
            >
              <span style={{ color: "#64748b" }}>
                {isRedirecting
                  ? "Opening your portfolio..."
                  : "Redirecting automatically"}
              </span>

              <strong
                style={{
                  color: "#0f172a",
                  flexShrink: 0,
                }}
              >
                {secondsLeft}s
              </strong>
            </div>

            <div
              style={{
                width: "100%",
                height: "7px",
                backgroundColor: "#e2e8f0",
                borderRadius: "999px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  width: `${progress}%`,
                  height: "100%",
                  backgroundColor: "#2563eb",
                  borderRadius: "999px",
                  transition: "width 1s linear",
                }}
              />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

const router = createBrowserRouter([
  {
    path: "*",
    element: <RedirectPage />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
